module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0059.jpg?v=80898481";